import { defineStore } from 'pinia';
import { getClientRequestDetailApi } from '@Api/requestFlow.api';
import type { ClientRequestDetail } from '@Types/ClientRequestDetail.interface';

export const useRequestDetailsStore = defineStore('requestDetails', {
    state: () => ({
        requestDetails: null as ClientRequestDetail | null,
    }),
    getters: {
        isMppPurchased: (state) => state.requestDetails?.protectionPlan?.isPurchased ?? false,
    },
    actions: {
        async fetchRequestDetails(): Promise<{ success: boolean, error?: unknown }> {
            try {
                this.requestDetails = await getClientRequestDetailApi();
                return { success: true };
            } catch (error) {
                console.error('Failed to fetch request details:', error);
                return { success: false, error };
            }
        },
    },
});
